import _ from 'lodash';

export default {
  computed: {
    sponsors() {
      return _.orderBy(_.filter(this.$store.state.config.sponsors, s => s.photo), 'order');
    }
  }
};
